import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Sparkles, Linkedin, Twitter, Instagram, Mail, LogIn } from "lucide-react";

export default function MarketingShell({ children, content, current }) {
  const links = [
    { to: "/", label: "Home", key: "home" },
    { to: "/clinics", label: "Clinics", key: "clinics" },
    { to: "/about", label: "About", key: "about" },
    { to: "/contact", label: "Contact", key: "contact" },
  ];
  return (
    <div className="min-h-screen bg-mr-bg text-mr-primary">
      <header className="glass-header sticky top-0 z-40">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3" data-testid="marketing-logo">
            <div className="h-8 w-8 rounded-lg bg-mr-primary text-white flex items-center justify-center">
              <Sparkles className="h-4 w-4" />
            </div>
            <div className="leading-tight">
              <p className="font-display font-semibold text-[15px]">MedRewards</p>
              <p className="text-[10px] uppercase tracking-[0.22em] text-mr-secondary">Healthcare Loyalty</p>
            </div>
          </Link>
          <nav className="hidden md:flex items-center gap-1">
            {links.map((l) => (
              <Link
                key={l.key}
                to={l.to}
                data-testid={`nav-${l.key}`}
                className={`px-4 py-2 text-sm rounded-full transition-colors ${current === l.key ? "text-mr-primary bg-[#E2E8F0]" : "text-mr-secondary hover:text-mr-primary hover:bg-[#E2E8F0]"}`}
              >
                {l.label}
              </Link>
            ))}
          </nav>
          <div className="flex items-center gap-1 sm:gap-2">
            <Link to="/clinics"><Button data-testid="marketing-patient-signin-btn" variant="ghost" size="sm" className="rounded-full text-mr-primary hover:text-mr-primary hover:bg-[#E2E8F0]"><LogIn className="h-3.5 w-3.5 mr-1.5" /> Patient sign in</Button></Link>
            <Link to="/register-clinic"><Button data-testid="marketing-register-clinic-btn" size="sm" className="rounded-full bg-mr-primary hover:bg-[var(--mr-primary-hover)] hidden sm:inline-flex">Register your clinic</Button></Link>
            <Link to="/admin/login"><Button data-testid="marketing-admin-btn" variant="ghost" size="sm" className="rounded-full hidden sm:inline-flex">Clinic Admin</Button></Link>
          </div>
        </div>
      </header>

      {children}

      <footer className="border-t border-mr mt-16 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-12 grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-3">
              <div className="h-8 w-8 rounded-lg bg-mr-primary text-white flex items-center justify-center"><Sparkles className="h-4 w-4" /></div>
              <p className="font-display font-semibold text-mr-primary">MedRewards</p>
            </div>
            <p className="text-mr-secondary text-sm mt-3 max-w-xs">{content?.footer?.tagline || "Built for healthcare providers in the UAE."}</p>
          </div>
          <div>
            <p className="label-eyebrow text-mr-secondary mb-3">Platform</p>
            <ul className="space-y-2 text-sm">
              <li><Link to="/clinics" className="text-mr-primary hover:text-mr-accent">Browse clinics</Link></li>
              <li><Link to="/about" className="text-mr-primary hover:text-mr-accent">About us</Link></li>
              <li><Link to="/contact" className="text-mr-primary hover:text-mr-accent">Contact</Link></li>
            </ul>
          </div>
          <div>
            <p className="label-eyebrow text-mr-secondary mb-3">Legal</p>
            <ul className="space-y-2 text-sm">
              <li><Link to="/privacy" className="text-mr-primary hover:text-mr-accent">Privacy Policy</Link></li>
              <li><Link to="/terms" className="text-mr-primary hover:text-mr-accent">Terms of Service</Link></li>
            </ul>
          </div>
          <div>
            <p className="label-eyebrow text-mr-secondary mb-3">Connect</p>
            {content?.contact?.email && (
              <a href={`mailto:${content.contact.email}`} className="text-mr-primary hover:text-mr-accent text-sm flex items-center gap-2"><Mail className="h-4 w-4" /> {content.contact.email}</a>
            )}
            <div className="mt-3 flex items-center gap-2">
              {content?.contact?.linkedin && <a href={content.contact.linkedin} target="_blank" rel="noreferrer" className="h-8 w-8 rounded-full bg-mr-bg hover:bg-[#E2E8F0] flex items-center justify-center"><Linkedin className="h-4 w-4 text-mr-primary" /></a>}
              {content?.contact?.twitter && <a href={content.contact.twitter} target="_blank" rel="noreferrer" className="h-8 w-8 rounded-full bg-mr-bg hover:bg-[#E2E8F0] flex items-center justify-center"><Twitter className="h-4 w-4 text-mr-primary" /></a>}
              {content?.contact?.instagram && <a href={content.contact.instagram} target="_blank" rel="noreferrer" className="h-8 w-8 rounded-full bg-mr-bg hover:bg-[#E2E8F0] flex items-center justify-center"><Instagram className="h-4 w-4 text-mr-primary" /></a>}
            </div>
          </div>
        </div>
        <div className="border-t border-mr py-6 text-center text-sm text-mr-secondary">
          © {new Date().getFullYear()} MedRewards · All rights reserved.
        </div>
      </footer>
    </div>
  );
}
